<template>
  <div class="container-view page-view">
    <!-------------------------------------------------------页面左侧部分--------------------------------------------------------->
    <section class="page_left">
      <!--广东省冷藏车情况-->
      <div class="content_area total-content height74">
        <div class="content_main" v-loading="vehicleAnalyLoading">
          <div class="content_title">广东省冷藏车情况</div>
          <div class="vehicleTotal">
            <template v-for="(v, i) in totalDomData">
              <div
                :key="i"
                :class="['center_total', `center_total_${i} `, { mr0: i == 3 }]"
              >
                <div>
                  <p class="title">{{ v.name }}</p>
                  <p>
                    <span class="number" v-if="i === totalDomData.length - 1"
                      >61.73</span
                    >
                    <span class="number" v-else>{{ v.value }}</span>
                    <span class="unit">{{ v.unit }}</span>
                  </p>
                </div>
                <div :class="`icon total_icon_${i}`"></div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!--广东省（粤牌）冷藏车-->
      <div class="content_area left_bottom-vehicle">
        <div>
          <div class="content_title">{{ vehicleDomObj.title }}</div>
          <div class="content_main" v-loading="vehicleLoading">
            <div>
              <div>
                <p class="name">{{ vehicleDomObj.name1 }}</p>
                <p class="number">{{ vehicleDomObj.value1 }}</p>
              </div>
              <div>
                <p class="name">{{ vehicleDomObj.name2 }}</p>
                <p class="number">{{ vehicleDomObj.value2 }}</p>
              </div>
            </div>
            <div
              class="echartsColdVel"
              ref="echartsColdVel"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
      </div>
    </section>
    <!-------------------------------------------------------页面中间部分------------------------------------------------------->
    <section class="page_center">
      <div
        class="page_center-map"
        ref="page_center-map"
        v-loading="mapLoading"
      ></div>
      <div class="area-chart-content" v-loading="centerBottmLoading">
        <div class="areaChartDom" ref="mileageComparison"></div>
      </div>
    </section>
    <!-------------------------------------------------------页面右侧部分------------------------------------------------------->
    <section class="page_right">
      <!--广东省冷库情况-->
      <div class="content_area right-content">
        <div class="content_main storage" v-loading="storageLoading">
          <div class="content_title">
            <span>广东省冷库情况</span>
            <span class="time-show">{{ curTime }}</span>
          </div>
          <div class="storage-top">
            <template v-for="(v, i) in storageDomData">
              <div :key="i">
                <div class="storage-box">
                  <span :class="`number${i}`"> {{ v.value }}</span>
                  <span class="unit" v-if="i == 3"> 万m³ </span>
                </div>

                <p :class="`name${i}`">
                  {{ v.name }}
                </p>
              </div>
            </template>
          </div>
          <div class="echart_storage" style="font-size: 1rem">
            <div class="online" ref="echartOnline"></div>
            <div class="upToStandard" ref="echartUpToStandard"></div>
          </div>
        </div>
      </div>
      <!--城市冷链数据排行Top5-->
      <div class="content_area center-content right-content">
        <div v-loading="storageChangeLoading">
          <div class="content_title">城市冷链数据排行Top5</div>
          <div class="radio-content">
            <el-radio-group v-model="topRadio" @input="topSwitch">
              <el-radio :label="1">企业</el-radio>
              <el-radio :label="2">冷库</el-radio>
              <el-radio :label="3">车辆</el-radio>
            </el-radio-group>
          </div>
          <div
            class="storageChange"
            ref="echartStorageChange"
            style="font-size: 1rem"
          ></div>
        </div>
      </div>
      <!--指定区域进出次数Top5-->
      <div class="content_area right_bottom-storage right-bottom-content">
        <div>
          <div class="content_title">指定区域进出次数Top5</div>
          <div class="content_main" v-loading="storageInOutLoading">
            <div
              :class="`echartsStorageInOut0`"
              ref="echartsStorageInOut"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Echarts from "echarts";
import moment from "moment";
import {
  FetchVehicleDataAnalysis,
  FetchVehicleData,
  fetchColdVelData,
  fetchStorageData,
  fetchStorageChangeData,
  fetchNumberByRealTime,
  fetchMapData,
  FetchNumberByAreaName,
  FetchCompanyNumAndRateByAreaName,
  FetchCompanyInfoByCity,
  fetchStorageInOutData,
  getInOutAreaFlow
} from "@/api/home/gdHome.js";
import echartsHome from "./echartsHome.js";
import {
  converData,
  handleMapData,
  converVehicleData,
  handleCityData
} from "./chartConfig.js";
export default {
  name: "gdHome",
  data() {
    return {
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      vehicleAnalyLoading: false,
      dailyMileage: 0,
      topRadio: 1,
      // -----------------------  城市冷链配送车  进口冷链食品专用车 -----------------------
      vehicleLoading: false,
      vehicleDomObj: {
        title: "广东省（粤牌）冷藏车",
        name1: "今日运行数",
        name2: "总车数",
        value1: 0,
        value2: 0
      },
      storageLoading: false,
      storageDomData: [
        {
          name: "仓库总数",
          value: 0
        },
        {
          name: "区位总数",
          value: 0
        },
        {
          name: "监测点总数",
          value: 0
        },
        {
          name: "仓库总吨位",
          value: 0
        }
      ],
      storageChangeLoading: false,
      storageInOutLoading: false,
      centerBottmLoading: false,
      c: [
        {
          title: "冷库进出次数Top10"
        }
      ],
      totalLoading: false,
      curTime: "",
      timer: null,
      totalDomData: [
        {
          name: "入驻企业总数",
          value: 0,
          unit: "家"
        },
        {
          name: "车辆总数",
          value: 0,
          unit: "辆"
        },
        {
          name: "省内冷藏车在线数量",
          value: 0,
          unit: "辆"
        },
        {
          name: "省内冷藏车行驶里程",
          value: 0,
          unit: "公里/车"
        },
        {
          name: "省内冷藏车运行时长",
          value: 0,
          unit: "小时/车"
        },
        {
          name: "省内冷藏车进出车次",
          value: 0,
          unit: "次"
        },
        {
          name: "平均运行速度",
          value: 0,
          unit: "公里/小时"
        },
        {
          name: "平均使用率",
          value: 0,
          unit: "%"
        }
      ],
      coldChainData: [], // 冷链排行榜数据
      mapLoading: false,
      echartsMapObj: null,
      mapGuangdongOutlineGeo: {}, // 广东的地图 geo 数据
      mapChartData: {
        companyList: [],
        freezerList: [],
        storageList: []
      },
      isGoDown: true // 是否下钻地图
    };
  },
  created() {},
  mounted() {
    this.getVelMileageData(); // 广东省冷藏车情况数据
    this.getColdVelData(); // 广东省（粤牌）冷藏车
    this.getStorageData(); // 仓库数据
    this.getNumberByRealTime(); // 企业与车辆总数
    this.getColdChainTop(); // 城市冷链数据排行榜Top5
    this.getInOutTop(); // 进出场次数排行榜Top5
    this.getRoadHaulData();
    this.initMap();
    this.$nextTick(() => {
      echartsHome.resizeEcharts();
    });
    window.onresize = () => {
      this.resetEcharts();
    };
    this.time();
  },
  methods: {
    // 实时时间
    time() {
      this.curTime = moment().format("YYYY-MM-DD  HH:mm:ss");
      this.timer = setTimeout(this.time, 1000); //设定定时器，循环运行
    },
    // 重置echarts
    resetEcharts() {
      this.echartsMapObj && this.echartsMapObj.resize();
    },
    // 渐变色
    setLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        0,
        0,
        1,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    /*****************************广东省冷藏车情况*************************/
    // 企业与车辆总数
    async getNumberByRealTime() {
      try {
        this.vehicleAnalyLoading = true;
        let res = await fetchNumberByRealTime();
        if (res.code) {
          this.totalDomData[0].value = this.handleData(res.result.comparyNum);
          this.totalDomData[1].value = this.handleData(
            res.result.coldStorageVehicleNum
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 广东省冷藏车情况数据
    async getVelMileageData() {
      try {
        const res = await FetchVehicleDataAnalysis();
        if (res.code === 1) {
          this.totalDomData[2].value = this.handleData(res.result.dailyMileage);
          this.totalDomData[3].value = this.handleData(
            res.result.avgDailyMileage
          );
          this.totalDomData[4].value = this.handleData(
            res.result.avgDailyRunningTime
          );
          this.totalDomData[5].value = this.handleData(
            res.result.stopVehicleCount
          );
          this.totalDomData[6].value = this.handleData(
            res.result.avgOperatingSpeed
          );
          this.totalDomData[7].value = this.handleData(
            res.result.avgServiceRate
          );
        }
      } finally {
        this.vehicleAnalyLoading = false;
      }
    },
    async getRoadHaulData() {
      try {
        this.centerBottmLoading = true;
        const res = await FetchVehicleData();
        if (res.code === 1) {
          this.initVelSpeedEcharts(res.result);
        }
      } finally {
        this.centerBottmLoading = false;
      }
    },

    // 冷藏车行驶里程对比
    initVelSpeedEcharts(data) {
      const dateList = [],
        frontDate = [],
        afterDate = [],
        bottomData = [];
      data.forEach(item => {
        dateList.push(item.month);
        frontDate.push(item.valueAfter);
        afterDate.push(item.valueFront);
        bottomData.push(0);
      });
      echartsHome.drawPillarLineChart(this.$refs.mileageComparison, {
        dateList,
        frontDate,
        afterDate,
        bottomData
      });
    },
    /******************************（粤牌）冷藏车*********************************/
    // （粤牌）冷藏车详情
    async getColdVelData() {
      try {
        this.vehicleLoading = true;
        let { code, result, message } = await fetchColdVelData();
        if (code) {
          if (result) {
            this.vehicleDomObj.value2 = result.cityVehicleCount;
            this.vehicleDomObj.value1 = result.cityVehicleCountForDay;
            this.initColdVelEcharts(result.cityRateToday);
          }
        } else {
          this.errorMessage(
            message || "获取城市冷链配送车、进口冷链食品专用车数据失败"
          );
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.vehicleLoading = false;
      }
    },
    // 冷链车饼图
    initColdVelEcharts(rateValue) {
      echartsHome.drawDashBoardChart(this.$refs.echartsColdVel, rateValue, {
        title: "车辆运行率"
      });
    },
    /******************************冷库数据*********************************/
    // 请求数据
    async getStorageData() {
      this.storageLoading = true;
      let res = await fetchStorageData();
      if (res.code) {
        let data = res.result;
        this.storageDomData[0].value = data.storageNum;
        this.storageDomData[1].value = data.areaLabel;
        this.storageDomData[2].value = data.areaCount;
        this.storageDomData[3].value = data.storageWeight;
        this.getStorageChangeData(); // 冷库温度变化趋势
      }
    },
    /******************************广东省冷库情况*********************************/
    // 温度在线率与达标率
    async getStorageChangeData() {
      let res = await fetchStorageChangeData();
      let data = res.result;
      // 初始化温度在线率与温度达标率echarts
      this.initStorageEcharts(0, data[data.length - 1].onlineRate);
      this.initStorageEcharts(1, data[data.length - 1].qualifyRate);
      this.storageLoading = false;
    },
    // 初始化温度在线率与温度达标率echarts
    initStorageEcharts(type, rateValue) {
      if (type == 0) {
        echartsHome.drawDashBoardChart(this.$refs.echartOnline, rateValue, {
          title: "温度在线率"
        });
      } else {
        echartsHome.drawDashBoardChart(
          this.$refs.echartUpToStandard,
          rateValue,
          {
            title: "温度达标率"
          }
        );
      }
    },
    /* 排行榜Top5 */
    topSwitch(index) {
      let coldChain = [],
        dataX = [],
        dataValue = [],
        maxValueList = [],
        maxValue = 0;
      switch (index) {
        case 1:
          coldChain = this.coldChainData.comparyList;
          maxValue = 150;
          break;
        case 2:
          coldChain = this.coldChainData.coldSorageList;
          maxValue = 2000000;
          break;
        case 3:
          coldChain = this.coldChainData.vehicleList;
          maxValue = 1500;
          break;
      }
      coldChain.forEach(item => {
        dataX.push(item.cityName);
        dataValue.push(item.countNum);
        maxValueList.push(maxValue);
      });
      this.$nextTick(() => {
        echartsHome.drawpillarChart(this.$refs.echartStorageChange, {
          dataX,
          dataValue,
          maxValueList
        });
      });
    },
    // 城市冷链排行榜
    async getColdChainTop() {
      try {
        this.storageChangeLoading = true;
        const res = await fetchStorageInOutData();
        const dataValue = [],
          dataX = [],
          maxValueList = [],
          maxValue = 150;
        if (res.code === 1) {
          this.coldChainData = res.result;
          res.result.comparyList.forEach(item => {
            dataX.push(item.cityName);
            dataValue.push(item.countNum);
            maxValueList.push(maxValue);
          });
          echartsHome.drawpillarChart(this.$refs.echartStorageChange, {
            dataX,
            dataValue,
            maxValueList
          });
        }
      } finally {
        this.storageChangeLoading = false;
      }
    },
    // 区域进出次数排行榜
    async getInOutTop() {
      try {
        this.storageInOutLoading = true;
        const res = await getInOutAreaFlow();

        const dataValue = [],
          dataX = [];
        if (res.code === 1) {
          res.result.forEach(item => {
            dataX.push(item.name);
            dataValue.push(item.countNum);
          });
          echartsHome.drawTopChart(this.$refs.echartsStorageInOut, {
            dataX,
            dataValue
          });
        }
      } finally {
        this.storageInOutLoading = false;
      }
    },

    /*****************************中间部分地图数据*************************/
    // 初始化地圖
    async initMap() {
      // 获取地区内部/外部轮廓地理位置信息
      let geoDirName = this.$GLOBAL_CONFIG.home.map.geoDirName; // geo文件件
      let geoPromises = [
        import(`@/assets/geo/${geoDirName}/inline.json`),
        import(`@/assets/geo/${geoDirName}/outline.json`),
        import(`@/assets/geo/${geoDirName}/guangzhou/outline.json`)
      ];
      let [inlineGeo, outlineGeo, guangdongOutlineGeo] = await Promise.all(
        geoPromises
      );

      // 初始化地图
      this.mapOutlineGeo = Object.freeze(outlineGeo);
      this.mapGuangdongOutlineGeo = Object.freeze(guangdongOutlineGeo);
      Echarts.registerMap("inlineMap", inlineGeo);
      Echarts.registerMap("outlineMap", outlineGeo);
      this.getMapData();
    },
    // 请求数据
    async getMapData() {
      try {
        this.mapLoading = true;
        let [mapData, vehicleData, companyData] = await Promise.all([
          fetchMapData(),
          FetchNumberByAreaName(),
          FetchCompanyNumAndRateByAreaName()
        ]);
        if (mapData.code && vehicleData.code && companyData.code) {
          this.mapChartData = {
            companyList: converData(companyData.result || []),
            freezerList: handleMapData(mapData.result.freezerLonLatList || []),
            storageList: handleMapData(mapData.result.storageLonLatList || []),
            vehicleList: converVehicleData(vehicleData.result || [])
          };
        } else {
          this.errorMessage("获取地图数据数据失败");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.mapLoading = false;
        this.initMapEcharts("", this.mapChartData);
      }
    },
    // 初始化地图echarts
    initMapEcharts(cityName = "", data = {}) {
      const mapChartData = data;
      const option = {
        legend: {
          data: ["入驻企业", "冷库", "冷柜"],
          orient: "horizontal",
          textStyle: {
            color: "#666"
          },
          top: "2%",
          left: 20
        },
        tooltip: {
          show: true
        },
        visualMap: {
          show: true,
          type: "piecewise",
          right: 10,
          bottom: 20,
          calculable: true,
          seriesIndex: [3],
          hoverLink: false,
          // 数据颜色范围，值越大颜色越深
          pieces: [
            {
              min: 100,
              color: this.setLinearColor("#006FEC", "#3B45F4")
            },
            {
              min: 76,
              max: 100,
              color: this.setLinearColor("#2B84EF", "#5B63F6")
            },
            {
              min: 51,
              max: 75,
              color: this.setLinearColor("#549CF2", "#7A81F7")
            },
            {
              min: 26,
              max: 50,
              color: this.setLinearColor("#7CB3F6", "#999EF9")
            },
            {
              min: 0,
              max: 25,
              color: this.setLinearColor("#A4CAF9", "#B8BCFB")
            }
          ]
        },
        geo: {
          name: cityName + "inlineMap",
          type: "map",
          map: cityName + "inlineMap",
          roam: true,
          zoom: 1,
          top: "5%",
          bottom: "5%",
          left: "5%",
          right: "13%",
          tooltip: {
            show: false
          },
          label: {
            normal: {
              show: true,
              position: "inside", //显示位置
              offset: [0, 0], //偏移设置
              color: "#fff",
              textShadowColor: "rgba(0,0,0,0.3)",
              textShadowBlur: 2,
              textShadowOffsetX: 0,
              textShadowOffsetY: 4,
              fontWeight: "lighter",
              fontSize: 12
            },
            emphasis: {
              color: "#fff"
            }
          },
          itemStyle: {
            normal: {
              borderColor: "#fff",
              borderWidth: 1
            },
            emphasis: {
              areaColor: "#3648F3"
            }
          },
          regions: [
            {
              name: "东沙群岛",
              itemStyle: {
                areaColor: "#A8C8FA"
              },
              label: {
                color: "#333"
              }
            }
          ]
        },
        series: [
          {
            name: "入驻企业",
            type: "scatter",
            coordinateSystem: "geo",
            itemStyle: {
              color: "#ff9600" //波纹圈颜色
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            data: mapChartData.companyList
          },
          {
            name: "冷库",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#00b7f4"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            data: mapChartData.storageList
          },
          {
            name: "冷柜",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#01af3c"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              extraCssText: "width:300px; white-space:pre-wrap" // 额外添加到浮层的css样式，用于换行。
            },
            data: mapChartData.freezerList
          },
          {
            type: "map",
            map: cityName + "inlineMap",
            geoIndex: 0,
            roam: true,
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <p style="font-size:18px;margin:0px">${params.name}</p>
                  <p>
                    <span style="display:block;margin:5px 0">入住企业总数：${params.data.comparyNum}</span>
                    <span style="display:block;margin:5px 0">车辆总数：${params.value}</span>
                    <span style="display:block;margin:5px 0">冷库总数：${params.data.storageNum}</span>
                    <span style="display:block;margin:5px 0">冷柜总数：${params.data.freezerNum}</span>
                  </p>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.vehicleList,
            label: {
              emphasis: {
                show: false
              },
              normal: {
                show: false
              }
            }
          }
        ]
      };
      if (this.echartsMapObj) {
        this.echartsMapObj.clear();
      }
      console.log(mapChartData, 111);
      this.echartsMapObj = Echarts.init(this.$refs["page_center-map"]);
      this.echartsMapObj.setOption(option);

      this.echartsMapObj.on("click", this.dropdown);
      this.isGoDown && this.echartsMapObj.on("dblclick", this.dropUp);
    },
    // 下钻城市
    async dropdown(params) {
      if (params.componentSubType !== "map") return;
      if (
        !this.isGoDown ||
        params.name === "广东省" ||
        params.name === "东沙群岛"
      )
        return;
      let code = this.conversion(params.name);
      let json = await import(`@/assets/geo/guangdong/couties/${code}.json`);

      // 初始化地图
      Echarts.registerMap(params.name + "inlineMap", json);
      this.fetchCenterCompanyData(params.name, params.data.bin);
      this.isGoDown = false;
    },
    // 获取地图下钻二级市，区，县数据
    async fetchCenterCompanyData(cityName = "", bin) {
      try {
        this.mapLoading = true;
        let that = this;
        let [res, vehicleData] = await Promise.all([
          FetchCompanyInfoByCity({ cityName }),
          FetchNumberByAreaName(this.$qs.stringify({ bin: bin }))
        ]);
        if (res && vehicleData) {
          if (res.code === 1 && res.result) {
            that.mapChartData = {
              companyList: handleCityData(res.result.companyLonLatList || []),
              freezerList: handleMapData(res.result.freezerLonLatList || []),
              storageList: handleMapData(res.result.storageLonLatList || []),
              vehicleList: converVehicleData(vehicleData.result || [], "count")
            };
            this.initMapEcharts(cityName, that.mapChartData);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.mapLoading = false;
      }
    },
    // 筛选当前的车辆列表，将不属于当前地图的点过滤掉
    filterVehicle(vehicleList) {
      // 地图轮廓多边形的点的数据
      const polygonPoints =
        this.mapGuangdongOutlineGeo.features[0].geometry.coordinates[0][0];
      let result = null;

      // 过滤掉不属于该地区的点

      result = vehicleList.filter(item => {
        if (this.isInPolygon(item.value, polygonPoints)) {
          return item;
        }
      });
      return result;
    },
    /**
     * 判断当前点是否再地图 geoJSON 的多边形范围之内
     * @param {array} checkPoint 要判断的经纬度
     * @param {array} polygonPoints geoJSON 中的多边形数据
     * @return {boolean} 返回是否再当前多边形范围之内
     */
    isInPolygon(checkPoint, polygonPoints) {
      let counter = 0;
      let i;
      let xinters;
      let p1, p2;
      let pointCount = polygonPoints.length;
      p1 = polygonPoints[0];

      for (i = 1; i <= pointCount; i++) {
        p2 = polygonPoints[i % pointCount];
        if (
          checkPoint[0] > Math.min(p1[0], p2[0]) &&
          checkPoint[0] <= Math.max(p1[0], p2[0])
        ) {
          if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
            if (p1[0] != p2[0]) {
              xinters =
                ((checkPoint[0] - p1[0]) * (p2[1] - p1[1])) / (p2[0] - p1[0]) +
                p1[1];
              if (p1[1] == p2[1] || checkPoint[1] <= xinters) {
                counter++;
              }
            }
          }
        }
        p1 = p2;
      }
      if (counter % 2 == 0) {
        return false;
      } else {
        return true;
      }
    },

    // 返回上一层
    dropUp() {
      this.getMapData();
      this.isGoDown = true;
    },
    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      // return size;
      // 目前此页面不需要自适应，则注释下计算字体
      return (size / 1920) * this.clientWidth;
    },

    // 计算纵向向尺寸百分比
    calcYDirectionSizeByPercent(size) {
      // return size;
      // 目前此页面不需要自适应，则注释下计算字体
      return (size / 1080) * this.clientHeight;
    },
    // 千分符处理
    handleData(data) {
      let regex = /\d{1,3}(?=((\d{3})+$))/g;
      if ((data + "").indexOf(".") > -1) {
        regex = /\d{1,3}(?=((\d{3})+\.))/g;
      }
      let str = (data + "").replace(regex, "$&,");
      // let str = data.toLocaleString();
      return str;
    },
    conversion(name) {
      let code = 0;
      switch (name) {
        case "湛江市":
          code = 440800;
          break;
        case "茂名市":
          code = 440900;
          break;
        case "阳江市":
          code = 441700;
          break;
        case "江门市":
          code = 440700;
          break;
        case "云浮市":
          code = 445300;
          break;
        case "珠海市":
          code = 440400;
          break;
        case "中山市":
          code = 442000;
          break;
        case "佛山市":
          code = 440600;
          break;
        case "肇庆市":
          code = 441200;
          break;
        case "深圳市":
          code = 440300;
          break;
        case "东莞市":
          code = 441900;
          break;
        case "广州市":
          code = 440100;
          break;
        case "清远市":
          code = 441800;
          break;
        case "惠州市":
          code = 441300;
          break;
        case "韶关市":
          code = 440200;
          break;
        case "汕尾市":
          code = 441500;
          break;
        case "河源市":
          code = 441600;
          break;
        case "揭阳市":
          code = 445200;
          break;
        case "梅州市":
          code = 441400;
          break;
        case "汕头市":
          code = 440500;
          break;
        case "潮州市":
          code = 445100;
          break;
        default:
          code = 440100;
      }
      return code;
    }
  }
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: timeFontFamily;
  src: url("~@/assets/ledFont/LEDNum.woff");
}
.page-view {
  position: relative;
  box-sizing: border-box;
  height: 100% !important;
  padding: 20px 20px;
  background-color: #eff0f9;
  & > section {
    float: left;
    overflow: hidden;
  }
  .page_title {
    display: flex;
    align-items: center;
    position: absolute;
    left: 200px;
    height: 0.4rem;
    p {
      margin-right: 20px;
      color: #333;
      .name {
        color: #999;
      }
      .cBlue {
        color: #0066ff;
        font-weight: 600;
        font-size: 0.18rem;
      }
      .cGreen {
        color: #33cc00;
        font-weight: 600;
        font-size: 0.18rem;
      }
    }
  }
  .page_center {
    width: calc(50% - 30px);
    height: 100%;
    margin: 0 15px;

    &-map {
      width: 100%;
      height: 70%;
      background: #fff;
      border-radius: 8px;
    }
    .area-chart-content {
      width: 100%;
      height: 27%;
      background-color: #fff;
      margin-top: 0.2rem;
      border-radius: 8px;

      .content_title {
        font-size: 0.18rem;
        margin-left: 0.2rem;
        padding: 5px 0px;
        font-weight: bolder;
        margin-left: 0.2rem;
        padding: 5px 0px;
        font-weight: bolder;
      }

      .areaChartDom {
        width: 100%;
        height: 100%;
      }
    }
  }
  .page_left,
  .page_right {
    position: relative;
    width: 25%;
    height: 100%;
    .time-show {
      position: absolute;
      right: 0.2rem;
      color: #0066ff;
      font-size: 0.14rem;
    }
    $heights: (80, 80%), (35, 35%), (30, 30%), (20, 20%);
    @each $height, $heightPer in $heights {
      .height#{$height} {
        height: $heightPer;
      }
    }
    @mixin content-title() {
      display: flex;
      align-items: center;
      height: 0.4rem;
      font-size: 0.18rem;
      color: #333;
    }
    @mixin main-item() {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      p {
        margin: 0.15rem 0;
      }
      .number {
        font-size: 0.26rem;
        font-weight: 600;
        margin-right: 0.1rem;
      }
      .unit {
        font-size: 0.14rem;
      }
      .name {
        font-size: 0.16rem;
        color: #999;
      }
    }
    .content_area {
      width: 100%;
      background: #fff;
      border-radius: 8px;
      .content_title {
        font-size: 22px;
        margin-left: 0.2rem;
        padding: 5px 0px;
        font-weight: bolder;
        @include content-title();
      }

      // 车辆趋势
      .velTrend {
        .content_main-item {
          @include main-item();
          height: 50%;
          .number {
            margin-right: 0;
          }
          .unit {
            font-weight: 600;
          }
          .echartsOnline,
          .echartsTemp {
            width: 45%;
            height: 90%;
          }
        }
      }
    }
    //左下部分
    .left_bottom-vehicle,
    .right_bottom-storage {
      height: 27%;
      margin-top: 0.2rem;
      > div {
        float: left;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .content_title {
        @include content-title();
      }
      .content_main {
        @include main-item();
        height: calc(100% - 0.4rem);
        width: 100%;
        padding: 0 0.12rem;
        p {
          margin: 0.1rem 0;
        }
        .echartsColdVel,
        .echartsColdVel {
          width: 50%;
          height: 90%;
        }
      }
    }
    .center-content {
      margin-top: 0.2rem;
    }
    .right-content {
      height: 34%;
    }
    .right-bottom-content {
      height: 27%;
    }
    // 冷库数据分析
    .storage {
      &-top {
        padding: 0px 0.1rem 0.2rem 0px;
        display: flex;
        justify-content: space-around;
        > div {
          text-align: center;
          p {
            margin: 0rem 0;
          }
          .unit {
            font-size: 0.14rem;
            color: #aaa;
          }
        }
        .storage-box {
          text-align: center;
        }
        $colors: (0, #6fd57d), (1, #689cf8), (2, #ff7566), (3, #ffa648);
        @each $i, $color in $colors {
          .number#{$i} {
            display: inline-block;
            padding: 0px 10px;
            height: 45px;
            line-height: 45px;
            border-radius: 50%;
            font-size: 0.14rem;
            color: #fff;
            font-weight: 600;
            background-color: $color;
          }
          .name#{$i} {
            color: $color;
            margin-top: 0.05rem;
          }
        }
      }

      .echart_storage {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 1.3rem;
        div {
          width: 50%;
          height: 100%;
        }
      }
    }

    .radio-content {
      text-align: right;
      margin-top: 10px;
      padding-right: 50px;
    }
    // 冷库变化趋势
    .storageChange {
      width: 100%;
      height: 2rem;
    }
    //
    .echartsStorageInOut0,
    .echartsStorageInOut1 {
      width: 100%;
      height: 100%;
    }
    .echartsStorageInOut0 {
      padding: 0 0.01rem;
    }
    .total-content {
      height: 70%;
      .vehicleTotal {
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 0 0.2rem;
      }
      .center_total {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 38%;
        padding: 0.1rem 0.15rem;
        margin-right: 4%;
        margin-bottom: 0.2rem;
        border-radius: 10px;
        color: #fff;
        font-size: 0.16rem;
        &.mr0 {
          margin-right: 0 !important;
        }
        p {
          margin: 0.15rem 0;
        }
        .title {
          font-size: 0.17rem;
        }
        .number {
          font-size: 0.2rem;
          font-weight: 500;
        }
        .unit {
          display: inline-block;
          margin-left: 9px;
          font-size: 0.18rem;
        }
        .icon {
          position: relative;
          width: 0.3rem;
          height: 0.3rem;
          background: #ccc;
        }
      }

      $colors: (0, #32ba66, #8ce388), (1, #3772ed, #82adf3),
        (2, #ff573b, #ff8f8c), (3, #ffa244, #ffcc92), (4, #32ba66, #8ce388),
        (5, #3772ed, #82adf3), (6, #ff573b, #ff8f8c), (7, #ffa244, #ffcc92);
      @each $i, $colorStart, $colorEnd in $colors {
        .center_total_#{$i} {
          background: linear-gradient(to top, $colorStart 50%, $colorEnd 90%);
          .total_icon_#{$i} {
            position: absolute;
            right: 10px;
            bottom: 2px;
            background: url("~@/assets/images/gdHome/total_icon_#{$i}.png")
              no-repeat;
            background-size: 100% 100%;
            width: 0.6rem;
            height: 0.55rem;
          }
        }
      }
    }
  }
}
</style>
